
<div class="products">
  <v-row dense wrap>
    <v-col cols="12">
      <h1 class="display-1">{{ $t("PRODUCTS_HEADER") }}</h1>
      <br>
      <p class="subheading" v-html="$t('PRODUCTS_TEXT')"></p>
    </v-col>
    <v-col v-if="false" cols="12" class="whiteCard christmas">
      <v-row wrap row>
        <v-col class="iconFlex">
          <img :src="christmasImage" class="christmasImage"/>
        </v-col>
        <v-col class="textFlex">
          <p class="text"><b>Tipp: </b>Weihnachten steht vor der Tür! Profitieren Sie von unserer großen Auswahl an <b>Geschenkprodukten</b> weiter unten auf der Seite, um Ihren Liebsten eine Freude zu machen.</p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  <v-row wrap align="center">
    <v-col cols="12" md="4">
      <v-alert v-if="paymentMethodActive('KLARNA_LATER')" type="success" class="elevation-3 paymentPromotion" :value="true">
        {{ $t('PAY_PER_BILL_NOTICE') }}
      </v-alert>
    </v-col>
    <v-col cols="12" md="4">
      <DiscountBanner/>
    </v-col>
    <v-col cols="12" md="4" class="topButtonRow">
      <v-row wrap justify="end">
        <v-col cols="auto">
          <v-btn class="selectionButton" @click="goToStep(2)">
            <v-icon>arrow_back</v-icon>
            {{ $t("BUTTON_BACK_TO_IMAGES") }}
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-btn class="selectionButton" @click="goToStep(1)">
            <v-icon>add</v-icon>
            {{ $t("BUTTON_OTHER_CODE") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  <br>
  
  <!-- Product Category Tabs -->
  <v-row wrap v-if="availableCategories.length > 0">
    <v-col cols="12">
      <v-tabs v-model="selectedCategoryIndex" class="category-tabs" hide-slider>
        <v-tab class="category-chip">
          <v-icon v-if="false" left small>mdi-view-grid</v-icon>
          {{ $t('PRODUCTS_ALL_CATEGORIES') }}
        </v-tab>
        <v-tab v-for="category in availableCategories" :key="category.id" :class="['category-chip', { 'highlight-chip': category.highlight }]">
          <v-icon v-if="category.iconName" left small>{{ category.iconName }}</v-icon>
          {{ category.name }}
        </v-tab>
      </v-tabs>
    </v-col>
  </v-row>
  
  <v-row wrap class="layout product-row" justify="center">
    <v-col v-for="product in filteredProducts" :key="product.id" class="product-col">
      <span v-if="hasDiscount(product)" class="discountBadge">
        {{ formatDiscount(getDiscount(product)) }}
      </span>
      <v-card :class="{productCard: true, highlight: product.highlight}">
        <v-img
            :src="product.imageUrl"
            class="productImage"
            contain
            lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAN4AAADjCAMAAADdXVr2AAAAA1BMVEX///+nxBvIAAAASElEQVR4nO3BMQEAAADCoPVPbQdvoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOA8W9AAHiq1isAAAAAElFTkSuQmCC"></v-img>
        <v-card-title class="productHeader">
          {{ product.name }}
        </v-card-title>
        <v-card-subtitle>
          {{ product.subHeading }}
        </v-card-subtitle>

        <v-card-text class="productShortDescription">
          <p class="text--primary product-description" v-html="product.shortDescription"/>
        </v-card-text>

        <v-card-actions class="actions">
          <span :class="{priceTag: true, discounted: hasDiscount(product)}">{{ formatProductPrice(product) }}</span>
          <span class="priceTag instead" v-if="hasDiscount(product)">
            {{ formatPrice(product.setPriceInsteadOf) }}
          </span>
          <v-spacer/>
          <v-btn color="primary" :to="`/product/${product.id}`">{{ $t("BUTTON_SHOW_PRODUCT") }}</v-btn>
        </v-card-actions>

      </v-card>
    </v-col>
  </v-row>
  
  <!-- Show All Products Button -->
  <v-row v-if="selectedCategory !== null" justify="center" class="show-all-row">
    <v-col cols="auto">
      <v-btn large outlined color="primary" @click="showAllProducts">
        {{ $t('PRODUCTS_SHOW_ALL') }}
      </v-btn>
    </v-col>
  </v-row>
</div>
